import angular from 'angular';

angular.module('cxNotifications').directive('notificationBar', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: require('./notificationBar.html'),
      controllerAs: 'vm',

      link: function(scope, element, attrs) {
        scope.limit = Number(attrs['limit']) || -1; //Default no limit
      },
      controller: [
        '$scope',
        'notificationSvc',
        'flySvc',
        '$http',
        '$state',
        'moment',
        function($scope, notificationSvc, flySvc, $http, $state, moment) {
          const vm = this;
          vm.notificationSvc = notificationSvc;
          vm.now = moment.utc();

          $scope.$watch('vm.notificationSvc.barVisible', visible => {
            if (visible) {
              vm.now = moment.utc();
            }
          });

          const base = 'assets/templates/notifications/types/';
          vm.getNotificationTemplateUrl = function(item) {
            switch (item.type) {
              case 0:
                return base + 'other.tpl.html';
              case 104:
              case 200:
              case 201:
              case 202:
              case 203:
              case 205:
              case 206:
              case 207:
              case 210:
              case 211:
              case 212:
              case 213:
              case 214:
              case 215:
              case 218:
              case 219:
                return base + 'relationList.tpl.html';
              case 208:
              case 209:
                return base + 'companyOwnerExpiration.tpl.html';
              case 227:
              case 228:
                return base + 'auditorExpiration.tpl.html';
              case 100:
              case 103:
              case 204:
              case 400:
              case 1100:
              case 1101:
              case 1102:
                return base + 'action.tpl.html';
              case 1200:
                return base + 'employeeList.tpl.html';
              case 501:
              case 502:
                return base + 'todo.tpl.html';
              case 503:
                return base + 'task.tpl.html';
              case 500:
              case 600:
                return base + 'custom.tpl.html';
              case 700:
                return base + 'jobList.tpl.html';
              case 751:
                return base + 'error.tpl.html';
              case 800:
              case 801:
                return base + 'document.tpl.html';
              case 900:
                return base + 'connectAuthentication.tpl.html';
              case 901:
                return base + 'connectExternalProviderMessage.tpl.html';
              case 1000:
              case 1001:
              case 1002:
              case 1003:
              case 1004:
                return base + 'shareItem.tpl.html';
              default:
                return item.type >= 200 && item.type <= 300
                  ? `${base}relationList.tpl.html`
                  : `${base}default.tpl.html`;
            }
          };
        },
      ],
    };
  },
]);
